import { NgModule } from '@angular/core';
import { UIconPickerComponent } from './u-icon-picker/u-icon-picker.component';
import { UIconWrapperComponent } from './u-icon-picker-wrapper/u-icon-picker-wrapper.component';

@NgModule({
  declarations: [],
  imports: [
    UIconPickerComponent,
    UIconWrapperComponent,
  ],
  exports: [
    UIconPickerComponent
  ],
})
export class UIconPickerModule {}
